export const REDUCER_NAME = 'liveSaleSlice';

export interface iLiveSaleDTO {
  productId: string;
  startTime: string | Date;
  endTime: string | Date;
  discount: number;
  status?: boolean;
}

export interface iLiveSaleResponse {
  id: string;
  vendorId: string;
  productId: string;
  productName: string;
  productImage: string;
  productPrice: number;
  startTime: string;
  endTime: string;
  discount: number;
  status: 'Active' | 'Expired' | 'Upcoming';
  createdAt: string;
  updatedAt: string;
}

export interface iLiveSaleState {
  isLoading: boolean;
 liveSaleList: {
    data: iLiveSaleResponse[];
    message?: string;
  };
  activeLiveSales: iLiveSaleResponse[];
  errorMessage: string | null;
  currentLiveSale: iLiveSaleResponse | null;
}

export interface iUpdateStatusPayload {
  liveSaleId: string;
  status: 'Active' | 'Expired' | 'Upcoming';
}

export interface iMessageResponseType {
  message: string;
  id?: string;
}
